import { render, staticRenderFns } from "./SettingWechat.vue?vue&type=template&id=5605f494&scoped=true&"
import script from "./SettingWechat.vue?vue&type=script&lang=js&"
export * from "./SettingWechat.vue?vue&type=script&lang=js&"
import style0 from "./SettingWechat.vue?vue&type=style&index=0&id=5605f494&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5605f494",
  null
  
)

export default component.exports